import { Link, type LinkProps } from '@tanstack/react-router';
import * as m from '@/paraglide/messages';
import { CtaButton } from './subcomponents/cta-button';
import { SqueezeFooterLogo } from './subcomponents/logo';

export function SqueezeFinalCta({ onCta }: { onCta: () => void }) {
  return (
    <section className='px-4 py-14 text-center sm:px-7'>
      <h2 className='mb-7 text-[26px] font-extrabold tracking-tight text-balance sm:text-[30px]'>
        {m.funnel_sq_final_heading()}
      </h2>
      <CtaButton className='px-7 py-4 text-[17px]' onClick={onCta} />
    </section>
  );
}

export function SqueezeFooter() {
  return (
    <footer className='border-t border-steel-120 bg-white px-4 py-6 sm:px-7'>
      <div className='mx-auto flex max-w-[1160px] flex-wrap items-center justify-between gap-4'>
        <div className='flex items-center gap-3 text-[13px] text-steel-700'>
          <SqueezeFooterLogo />
          <span>
            {m.funnel_footer_copyright({ year: new Date().getFullYear() })}
          </span>
        </div>
        <nav className='flex flex-wrap gap-5'>
          <FooterLink to='/privacy'>
            {m.footer_link_privacy_policy()}
          </FooterLink>
          <FooterLink to='/terms'>{m.common_terms_of_service()}</FooterLink>
        </nav>
      </div>
    </footer>
  );
}

function FooterLink({
  to,
  children,
}: { children: React.ReactNode } & Pick<LinkProps, 'to'>) {
  return (
    <Link
      className='text-[13.5px] font-semibold text-steel-700 hover:text-azure-595'
      rel='noreferrer'
      target='_blank'
      to={to}
    >
      {children}
    </Link>
  );
}
